import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AcessoService } from 'src/app/service/acesso/acesso.service';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { Item } from './promocoes-cadastro/promocoes-cadastro.component';

@Injectable({
  providedIn: 'root',
})
export class PromocoesService {
  localStorage: LocalStorage = new LocalStorage();
  headers = new HttpHeaders();
  url_acesso: string;
  cabecalho: any;
  filial: string;

  // listaMotivos: Item[] = [];
  // listaAfastamentos: Item[] = [];
  // listaClassificacaoAto: Item[] = [];
  listaIdClassificacaoAto: Item[] = [];
  listaObservacoes: Item[] = [];
  listaCargosFuncoes: Item[] = [];

  constructor(private http: HttpClient, private acesso: AcessoService) {
    this.url_acesso = this.acesso.validarUrl();

    if (localStorage.getItem('util') != null) {
      this.localStorage = JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
      this.cabecalho = this.headers.append('sessao', this.localStorage.Sessao);

      this.filial = this.localStorage.FilialAtual.toString();
    }
  }

  buscarColaboradorMatricula(matricula: string) {
    return this.http.get(`${this.url_acesso}cadastro-todos-matricula/${matricula}/${this.filial}`, {
      headers: this.cabecalho,
    });
  }

  buscarPromocoes(matricula: number) {
    return this.http.get(
      `${this.url_acesso}promocoes/listar-promocoes/${matricula}/${this.filial}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  buscarCargosFuncoes(matricula: number, empfil: string) {
    return this.http.get(
      `${this.url_acesso}promocoes/listar-opcoes-fun-car/${matricula}/${empfil}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  buscarNiveisCargo(CodFun: string) {
    return this.http.get(`${this.url_acesso}promocoes/listar-opcoes-combo-niv/${CodFun}`, {
      headers: this.cabecalho,
    });
  }

  buscarCodigoPromocao() {
    return this.http.get(`${this.url_acesso}promocoes/listar-codigo-promocao`, {
      headers: this.cabecalho,
    });
  }

  buscarIdClassificacaoAto() {
    return this.http.get(`${this.url_acesso}falta-ao-trabalho/listar-id-classificacao-ato`, {
      headers: this.cabecalho,
    });
  }

  inserirPromocao(promocao: any) {
    return this.http.post(`${this.url_acesso}promocoes/inserir-promocoes`, promocao, {
      headers: this.cabecalho,
    });
  }

  inserirLista(listaNome: string, lista: Array<Item>) {
    if (listaNome == 'buscarIdClassificacaoAto') {
      this.listaIdClassificacaoAto = lista;
    }
    if (listaNome == 'buscarObservacoes') {
      this.listaObservacoes = lista;
    }
    if (listaNome == 'buscarCargosFuncoes') {
      this.listaCargosFuncoes = lista;
    }
  }

  retornarLista(listaNome: string) {
    if (listaNome == 'buscarIdClassificacaoAto') {
      return this.listaIdClassificacaoAto;
    }
    if (listaNome == 'buscarObservacoes') {
      return this.listaObservacoes;
    }
    if (listaNome == 'buscarCargosFuncoes') {
      return this.listaCargosFuncoes;
    }
  }

  deletarPromocao(empfil: string, matricula: number, Seq: number) {
    return this.http.delete(
      `${this.url_acesso}promocoes/excluir-promocao/${empfil}/${matricula}/${Seq}`,
      { headers: this.cabecalho }
    );
  }

  downloadPdf(empfil: string, matricula: number, tipo: string) {
    return this.http.get(
      `${this.url_acesso}relatorios-pdf/download-pdf/${empfil}/${matricula}/${tipo}`,
      {
        headers: this.cabecalho,
      }
    );
  }

  atualizarPromocao(Promocao: any) {
    console.log('payload', Promocao);
    return this.http.put(`${this.url_acesso}promocoes/atualizar-promocoes`, Promocao, {
      headers: this.cabecalho,
    });
  }

  buscarObservacoes() {
    return this.http.get(`${this.url_acesso}promocoes/listar-observacoes`, {
      headers: this.cabecalho,
    });
  }

  formatarDataBarra(data: string): string {
    if (!data || data.length !== 8) return data;
    const ano = data.substring(0, 4);
    const mes = data.substring(4, 6);
    const dia = data.substring(6, 8);

    return `${dia}/${mes}/${ano}`;
  }
}
